export const DEFAULT_WINDOWS_INTENSITY = 0.4;
export const DEFAULT_BODY_INTENSITY = 0.2;
export const DEFAULT_TIRES_INTENSITY = 0.2;
